<a routerLink='/game' class='btn'>Попробовать снова</a>
